// Imports
import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import VuexPersist from 'vuex-persist';
import localForage from 'localforage';

import * as modules from './modules'

Vue.use(Vuex)

const rawUsername = (username) => {
  if (username == null || username === '') return null;
  return String(username).replace(/[^\w]/gi, '');
};

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: localForage, 
  asyncStorage: true,
  reducer: (state) => {
    if (!state.user) return state;

    const user = { ...state.user };

    if (user.cpf != null && user.profile?.cpf == null) {
      user.profile = { ...user.profile, cpf: user.cpf };
    }
    delete user.cpf;

    if (user.username != null) {
      user.username = rawUsername(user.username);
    }

    return { ...state, user };
  },
})

const store = new Vuex.Store({
  plugins: [pathify.plugin, vuexLocalStorage.plugin],
  modules,
})

export default store
